import { Col, Row } from 'antd';
import styles from './DatastoreScalingInfoCard.module.less';
import SmallContainer from '../../ccx/common/SmallContainer';
import { useEffect, useState } from 'react';
import DeploymentsItem from '../../../types/DeploymentsItem';
import CloudProvider from '../../../types/CloudProvider';
import AppLogoBrandAws from '../../ccx/common/AppLogoBrandAws';
import AppLogoBrandSafespring from '../../ccx/common/AppLogoBrandSafespring';
import AppLogoBrandCityCloud from '../../ccx/common/AppLogoBrandCityCloud';
import AppLogoBrandGoogleCloud from '../../ccx/common/AppLogoBrandGoogleCloud';
import AppLogoBrandLintasarta from '../../ccx/common/AppLogoBrandLintasarta';
import AppLogoBrandVultr from '../../ccx/common/AppLogoBrandVultr';
import AppLogoBrandElastx from '../../ccx/common/AppLogoBrandElastx';
import AppFlagIcon from '../../ccx/common/AppFlagIcon';
import useContentDeployWizard from '../../../core/hooks/useContentDeployWizard';
import AppLogoBrandMardiaDb from '../../ccx/common/AppLogoBrandMardiaDb';
import AppLogoBrandPostgreSql from '../../ccx/common/AppLogoBrandPostgreSql';
import AppLogoBrandPercona from '../../ccx/common/AppLogoBrandPercona';
import AppLogoBrandRedis from '../../ccx/common/AppLogoBrandRedis';
import AppLogoBrandMssql from '../../ccx/common/AppLogoBrandMssql';
import AppLogoBrandSyseleven from '../../ccx/common/AppLogoBrandSyseleven';

interface DatastoreScalingInfoCardProps {
    dataStore: DeploymentsItem | undefined;
    countryCode: string | undefined;
    setCountryCode: Function;
}

export default function DatastoreScalingInfoCard({
    dataStore,
    setCountryCode,
    countryCode,
}: DatastoreScalingInfoCardProps) {
    const [cards, setCards] = useState<any>([]);
    const { deploymentOptions } = useContentDeployWizard();

    const getCloudProviderLogo = (p: CloudProvider) => {
        if (p.isAws()) return <AppLogoBrandAws height={15} width={24} />;
        if (p.isSafespring())
            return <AppLogoBrandSafespring height={18} width={50} />;
        if (p.isCityCloud())
            return <AppLogoBrandCityCloud height={15} width={50} />;
        if (p.isGoogle())
            return <AppLogoBrandGoogleCloud height={15} width={24} />;
        if (p.isLintasarta())
            return <AppLogoBrandLintasarta height={15} width={24} />;
        if (p.isVultr()) return <AppLogoBrandVultr height={15} width={24} />;
        if (p.isElastx()) return <AppLogoBrandElastx height={15} width={24} />;
        if (p.isSyseleven())
            return <AppLogoBrandSyseleven height={15} width={24} />;

        return null;
    };

    const getLogo = (ds: DeploymentsItem) => {
        if (ds.isMariaDb()) {
            return (
                <AppLogoBrandMardiaDb
                    useExtended={false}
                    width={40}
                    height={40}
                />
            );
        }
        if (ds.isPostgreSql()) {
            return (
                <AppLogoBrandPostgreSql
                    useExtended={false}
                    width={40}
                    height={40}
                />
            );
        }
        if (ds.isPercona()) {
            return (
                <AppLogoBrandPercona
                    useExtended={false}
                    width={40}
                    height={40}
                />
            );
        }
        if (ds.isRedis()) {
            return (
                <AppLogoBrandRedis useExtended={false} width={40} height={40} />
            );
        }
        if (ds.isMSSQL()) {
            return (
                <AppLogoBrandMssql useExtended={false} width={40} height={40} />
            );
        }
        return null;
    };

    useEffect(() => {
        if (deploymentOptions && dataStore) {
            setCountryCode(
                deploymentOptions
                    ?.getCloudRegions(dataStore.getCloudProvider().code)
                    ?.filter((r: any) => r.code === dataStore.cloudRegion)[0]
                    ?.countryCode
            );
        }
    }, [dataStore, deploymentOptions]);

    useEffect(() => {
        if (dataStore) {
            let cardData = [
                {
                    content: (
                        <SmallContainer
                            topChildren={
                                <div
                                    className={
                                        styles.DatastoreScalingInfoCardLogo
                                    }
                                >
                                    {getLogo(dataStore)}
                                </div>
                            }
                        />
                    ),
                    span: 2,
                },
                {
                    content: (
                        <SmallContainer
                            topChildren={
                                <>
                                    <div
                                        className={
                                            styles.DatastoreScalingInfoCardName
                                        }
                                    >
                                        {dataStore?.getName()}
                                    </div>
                                </>
                            }
                            middleChildren={
                                <>
                                    <div>{dataStore?.getDbVendorName()}</div>
                                </>
                            }
                        />
                    ),
                    span: 10,
                },
                {
                    content: (
                        <SmallContainer
                            topChildren={
                                <>
                                    {getCloudProviderLogo(
                                        dataStore.getCloudProvider()
                                    )}
                                    <div>
                                        {dataStore.getFullCloudProviderName()}
                                    </div>
                                </>
                            }
                            middleChildren={
                                <>
                                    {countryCode && (
                                        <AppFlagIcon code={countryCode} />
                                    )}
                                    <div>{dataStore.cloudRegion}</div>
                                </>
                            }
                        />
                    ),
                    span: 10,
                },
            ];

            setCards(cardData);
        }
    }, [dataStore, countryCode]);
    return (
        <div>
            <p>
                <strong>Datastore</strong>
            </p>
            <div className={styles.DatastoreScalingInfoCard}>
                <Row className={styles.DatastoreScalingInfoCardRow}>
                    {cards.map((c: any, i: number) => {
                        return (
                            <Col span={c.span} key={`cards${i}`}>
                                <SmallContainer
                                    testId={c.testId}
                                    topChildren={c.label}
                                    middleChildren={c.content}
                                />
                            </Col>
                        );
                    })}
                </Row>
            </div>
        </div>
    );
}
